import React, { useCallback, useMemo, useEffect } from 'react'
import { Card } from 'react-bootstrap'
import ReactTableBootstrap from 'react-table-bootstrap'
import TableActionItems from '../../../components/table-action-items/TableActionItems'
import { doRequestPost } from '../../../api'
import { toast } from 'react-toastify'
import { promiseCatch, doToast, rowEnabledText, getActions, addActionOnRow } from '../../../utils'
import { useGet } from '../../../hooks/process-data'
import { ProfileForm } from '../profile-form/ProfileForm'
import { useSelector } from 'react-redux'
import { ProfileTag } from '../profile-tag/ProfileTag'

export const ProfileView = () => {
  const { rows, isProcessing, setReload, error, setError } = useGet({
    url: '/profile'
  })

  const { permissions } = useSelector(store => store.session)
  const actions = getActions({ permissions, module: 'perfiles' })

  const rowItem = useCallback(({
    row = {},
    type = 'update'
  }) => {
    const rowId = row.id_profile

    const addButtonRow = ({ setModalShow, setCustomForm, setModalTitle, rowId, setForm, modalHide, data }) => {
      const buttonsRow = []
      if (actions?.permissions) {
        buttonsRow.push({
          variant: 'dark',
          icon: 'fas fa-tags',
          text: actions?.permissions?.name_action,
          onClick: () => {
            setModalTitle('Asignar Permisos')
            setCustomForm(true)
            setModalShow(true)
            setForm(<ProfileTag rowId={rowId} companyId={data.id_company} setReload={() => {
              setReload(true)
              modalHide()
            }} />)
          },
          minWidth: 100
        })
      }

      return buttonsRow
    }

    return <TableActionItems
      data={row}
      type={type}
      rowId={rowId}
      formRender={({ modalHide }) => {
        return <ProfileForm rowId={rowId} setReload={() => {
          setReload(true)
          modalHide()
        }} />
      }}
      doDelete={async ({ hideAlert, setProcessingAlert }) => {
        try {
          setProcessingAlert(true)
          const deleteRecord = await doRequestPost({
            url: '/profile/delete',
            data: {
              p_id_profile: rowId
            }
          })

          doToast({
            ...deleteRecord,
            toast
          })
          hideAlert()
          setReload(true)
        } catch (error) {
          promiseCatch({
            toast
          })
          setProcessingAlert(false)
        }
      }}
      addButtonRow={addButtonRow}
      showCreate={actions?.create}
      showUpdate={actions?.update}
      showDelete={actions?.delete}
    />
  }, [setReload, actions])

  const dtRows = useMemo(() => {
    const headItem = addActionOnRow({
      head: [
        { name: 'name_profile', text: 'Nombre', align: 'center' },
        { name: 'main_profile', text: 'Página Principal', align: 'center' },
        { name: 'enabled_profile', text: 'Estado', align: 'center', render: row => rowEnabledText({ enabled: row.enabled_profile }) },
      ],
      rowItem
    })

    return <ReactTableBootstrap
      head={[headItem]}
      rows={rows}
      isProcessing={isProcessing}
    />
  }, [rows, isProcessing, rowItem])

  useEffect(() => {
    if (error) {
      promiseCatch({
        toast
      })
      setError(false);
    }
  }, [error, setError])


  return <div className='row'>
    <div className="col-xl-2 col-lg-1"></div>
    <div className="col-xl-8 col-lg-10">
      <Card>
        <Card.Body>
          {rowItem({
            type: 'create'
          })}
          {dtRows}
        </Card.Body>
      </Card>
    </div>
  </div>
}